import * as processedWarranty from './processedWarranty';
import * as warrantyReport from './warrantyReport';
import * as warrantyInvoicing from './warrantyInvoicing';
import * as warrantyErrorRate from './warrantyErrorRate';

const reducers = {
  ...processedWarranty,
  ...warrantyReport,
  ...warrantyInvoicing,
  ...warrantyErrorRate,
};

export default reducers;
